import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Button } from '../button';
import { Modal } from '../modal';
export const Confirmation = (props) => {
    const { t } = useTranslation();
    const title = props.title || t('confirmation.title', 'Are you sure?');
    const message = props.message ||
        t('confirmation.message', 'Are you sure you want to perform this action?');
    const closeButtonText = props.closeButtonText || t('confirmation.close-button-text', 'Close');
    const confirmButtonText = props.confirmButtonText ||
        t('confirmation.confirm-button-text', "Yes, I'm sure");
    const ConfirmButtonElement = (_jsx(Button, { variant: "contained", onClick: props.onConfirm, color: props.confirmButtonColor, children: confirmButtonText }));
    const CloseButtonElement = (_jsx(Button, { variant: "outlined", onClick: props.onClose, color: props.closeButtonColor, children: closeButtonText }));
    return (_jsx(Modal, { maxWidth: "xs", fullWidth: true, open: props.open, onClose: props.onClose, title: title, actions: [ConfirmButtonElement, CloseButtonElement], children: message }));
};
